export const DuplicateIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2837_34824)">
        <path
          d="M3.75 18.3112C3.41667 18.3112 3.125 18.1862 2.875 17.9362C2.625 17.6862 2.5 17.3945 2.5 17.0612V4.4987H3.75V17.0612H13.625V18.3112H3.75ZM6.25 15.8112C5.91667 15.8112 5.625 15.6862 5.375 15.4362C5.125 15.1862 5 14.8945 5 14.5612V2.89453C5 2.5612 5.125 2.26953 5.375 2.01953C5.625 1.76953 5.91667 1.64453 6.25 1.64453H15.4167C15.75 1.64453 16.0417 1.76953 16.2917 2.01953C16.5417 2.26953 16.6667 2.5612 16.6667 2.89453V14.5612C16.6667 14.8945 16.5417 15.1862 16.2917 15.4362C16.0417 15.6862 15.75 15.8112 15.4167 15.8112H6.25ZM6.25 14.5612H15.4167V2.89453H6.25V14.5612ZM6.25 14.5612V2.89453V14.5612Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2837_34824">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
